import React, { useCallback } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { CandidateSourcingState } from '../candidateSourcingReducer';

const classes = {
  tabsContainer: {
    borderBottom: 1,
    borderColor: '#EEEEEE',
    margin: '25px 0'
  },
  tabs: {
    '& button': {
      fontFamily: 'Source Sans Pro',
      fontSize: '18px',
      letterSpacing: '0',
      color: '#939393',
      textTransform: 'none',
      minWidth: 'unset',
      '&:hover': {
        color: '#737373'
      },
      '&:focus': {
        outline: 'none'
      }
    },
    '& button.Mui-selected': {
      fontWeight: '600',
      color: '#084D6D'
    }
  },
  tabIndicator: {
    backgroundColor: '#5BC4BF'
  }
};

const TabSelector = ({
  candidateSourcingState,
  handleTabChange,
  tabIndicatorRef
}: {
  candidateSourcingState: CandidateSourcingState;
  handleTabChange: (event: React.SyntheticEvent, tabValue: number) => void;
  tabIndicatorRef: React.MutableRefObject<HTMLElement[]>;
}) => {
  const TabProps = useCallback((index: number) => {
    return {
      id: `candidate-sourcing-tab-${index}`,
      'aria-controls': `candidate-sourcing-tabpanel-${index}`
    };
  }, []);

  return (
    <Box sx={classes.tabsContainer}>
      <Tabs
        value={candidateSourcingState.selectedTab}
        onChange={handleTabChange}
        aria-label="candidate sourcing tabs"
        sx={{
          ...classes.tabs,
          '& .MuiTabs-indicator': {
            ...classes.tabIndicator,
            maxWidth: candidateSourcingState.indicatorWidth + 'px'
          }
        }}
      >
        <Tab
          label="Searches"
          {...TabProps(0)}
          ref={(el) => {
            if (el) tabIndicatorRef.current[0] = el;
          }}
          id="searches-tab-button"
        />
        <Tab
          label="Candidate Pools"
          {...TabProps(1)}
          ref={(el) => {
            if (el) tabIndicatorRef.current[1] = el;
          }}
          id="candidate-pools-tab"
        />
      </Tabs>
    </Box>
  );
};

export default TabSelector; 
